import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardActions } from './actions/card.actions';

@NgModule( {
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [ CardActions ]
} )
export class CardModule { }
